/** Fullwidth vertical bar required by the spec for item_variant. */
const VARIANT_SEPARATOR = '｜';
const COUPON_SEPARATOR = '|';
const COUPON_MAX_LENGTH = 100;

export function buildItemVariant(
  planTitle?: string,
  unitTitle?: string
): string | undefined {
  const parts = [planTitle, unitTitle]
    .map(part => (part ?? '').trim())
    .filter(part => part.length > 0);
  if (parts.length === 0) return undefined;
  return parts.join(VARIANT_SEPARATOR);
}

/**
 * Order-level coupon codes as one string: trimmed, de-duplicated, sorted
 * ascending, joined with "|". Sorted so the same set of codes always reports
 * the same value. Trailing codes are dropped once the 100-character parameter
 * cap is reached.
 */
export function normalizeCoupon(codes?: string[]): string | undefined {
  const cleaned = [
    ...new Set((codes ?? []).map(code => (code ?? '').trim()).filter(Boolean))
  ].sort();

  let joined = '';
  for (const code of cleaned) {
    const next = joined ? `${joined}${COUPON_SEPARATOR}${code}` : code;
    if (next.length > COUPON_MAX_LENGTH) break;
    joined = next;
  }

  return joined || undefined;
}
